import React, { createContext, useContext, useState, useEffect } from 'react';

const ConfigContext = createContext();

// LawnTrack fixed branding - NOT fetched from API
// This is a separate product from SnowTrack with its own identity
const LAWNTRACK_CONFIG = {
  appName: 'LawnTrack™',
  appTagline: 'Route Management for Lawn Care Pros',
  theme: {
    primaryColor: '#4CAF50',
    primaryDark: '#388E3C',
    primaryLight: '#81C784',
    secondaryColor: '#ff9800',
    secondaryDark: '#f57c00',
    secondaryLight: '#ffb74d',
    successColor: '#4caf50',
    warningColor: '#ff9800',
    errorColor: '#f44336',
    textColor: '#333333',
    textLight: '#666666',
    backgroundColor: '#f5f5f5',
    cardBackground: '#ffffff',
    borderColor: '#e0e0e0',
  },
  serviceTypes: {
    lawn_mowing: 'Lawn Mowing',
    edging: 'Edging',
    trimming: 'Trimming',
    leaf_cleanup: 'Leaf Cleanup',
    fertilizing: 'Fertilizing',
    aeration: 'Aeration',
    overseeding: 'Overseeding',
    weed_control: 'Weed Control',
  },
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const [config] = useState(LAWNTRACK_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Apply LawnTrack theme immediately on mount
    // No API fetch - LawnTrack has fixed branding
    setLoading(false);
  }, []);

  const getAppName = () => config.appName;
  const getAppTagline = () => config.appTagline;
  const getTheme = () => config.theme;
  const getServiceTypes = () => config.serviceTypes;

  const value = {
    config,
    loading,
    getAppName,
    getAppTagline,
    getTheme,
    getServiceTypes,
    refreshConfig: () => Promise.resolve(), // No-op for LawnTrack
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
};
